export enum OPTIONS {
  IS_UNTAXED_ITEM_NOTE_VISIBLE = 'isUntaxedItemNoteVisible',
  IS_CUSTOMER_NAME_VISIBLE = 'isCustomerNameVisible',
  IS_CONNECTION_STATUS_VISIBLE = 'isConnectionStatusVisible',
  IS_LOGO_VISIBLE = 'isLogoVisible',
  IS_REGISTER_CUSTOMER_VISIBLE = 'isRegisterCustomerVisible',
  IS_DEBUG_MODE = 'isDebugMode',
  IS_QRCODE_VISIBLE = 'isQRCodeVisible',
}
